export default __webpack_public_path__ + "static/media/img_csp.d51c2243.svg";